import PropTypes from "prop-types";
import React from "react";
import CSSModules from "react-css-modules";
import css from "./styles.scss";
import {
  ButtonGroup,
  ButtonOutline
} from "components/Global/Modal/Layout/Buttons";

const Footer = ({ goToAccessScreen, hideModal }) => (
  <ButtonGroup className={css.container}>
    <ButtonOutline
      title="Back"
      onClick={goToAccessScreen}
      className={css.grayButton}
    />
    <ButtonOutline
      title="Done"
      onClick={hideModal}
      className={css.grayButton}
    />
  </ButtonGroup>
);

Footer.propTypes = {
  goToAccessScreen: PropTypes.func.isRequired,
  hideModal: PropTypes.func.isRequired
};

export default CSSModules(Footer, css);
